module.exports = __webpack_public_path__ + "img/counter-to-value.ffda7143.png";